import * as signalR from '@microsoft/signalr';

import { type CreateAuthenticatedHubConnectionOptions } from './types';

export const createAuthenticatedHubConnection = ({
  url,
  accessTokenFactory,
  configureLogging,
  automaticReconnect = true
}: CreateAuthenticatedHubConnectionOptions): signalR.HubConnection => {
  let builder = new signalR.HubConnectionBuilder().withUrl(url, {
    accessTokenFactory
  });

  if (configureLogging) {
    builder = configureLogging(builder);
  }

  if (automaticReconnect) {
    builder = builder.withAutomaticReconnect();
  }

  return builder.build();
};
